import React from 'react';
import { EntityListing } from './EntityListing';
import { INACTIVE_ENTITIES_PAGE_SIZE, PAGE_NAME_REVIEW_AND_ACTIVATE } from './../../constants';
import { DeleteButton, BulkActivateButton } from './../../reusable/Form/Buttons';
import AssignToCategory from "./components/AssignToCategory";
import { ListingPageHeader } from './../../reusable/LightTable/Components'
import withSort from './../../reusable/LightTable/hoc/Sortable';
import withSearch from './../../reusable/LightTable/hoc/Searchable';
import withSelectionPaginated from './../../reusable/LightTable/hoc/SelectablePaginated';
import withPagination from './../../reusable/LightTable/hoc/Paginated';
import VeryLightTable from './../../reusable/LightTable/VeryLightTable';
import headerActions from './../../reusable/Header/Header.actions';
import { compose } from 'redux';
import actions from './../ReviewCompanies/ReviewCompanies.actions';
import { hashHistory } from 'react-router';
import {BulkPreviewButton} from "../../reusable/Form/Buttons";
import { FormattedMessage, injectIntl } from 'react-intl';
import reduxStore from '../../reduxStore';
import { sortBy } from 'lodash';

const Table = compose(
    withSelectionPaginated,
    withSort,
    withSearch,
    withPagination
)(VeryLightTable);

class InactiveEntityListing extends EntityListing {
    constructor(props) {
        super(props);

        const defaultLoadParams = {
            filters:    {query: "", categoryIdFilter: "defaultAllCategories", active: "non-active"},
            sorting:    reduxStore.getState().user.preferences.pagesTablesSort[PAGE_NAME_REVIEW_AND_ACTIVATE],
            pagination: {pageNumber: 0, pageSize: INACTIVE_ENTITIES_PAGE_SIZE},
            reset:      false
        };
        this.defaultLoadParams = this.loadParams = defaultLoadParams;

        this.handlePreviewAll = this.handlePreviewAll.bind(this);
        this.handlePreview = this.handlePreview.bind(this);
    }

    componentDidMount() {
        super.componentDidMount();
        headerActions.updateHeader('reviewCompanies');
    }

    getFilters() {
        const filters = super.getFilters();
        return filters.filter(filter => filter.field === "categoryIdFilter"); // return only the category filter
    }

    headerItems = [
        {
            key: "companyTitle",
            label: <FormattedMessage id='Entities_Edit_UIText_thirdPartyListing.titleColumnHeading'/>,
            sortable: true,
            persistableSort: PAGE_NAME_REVIEW_AND_ACTIVATE
        },
        {
            key: "customerCompanyId",
            label: <FormattedMessage id='Entities_Edit_UIText_thirdPartyListing.thirdPartyIdColumnHeading'/>,
            sortable: true,
            persistableSort: PAGE_NAME_REVIEW_AND_ACTIVATE
        },
        {
            key: "dunsNumber",
            label: <FormattedMessage id={"Entities_Review_Error_errorCompanies.CompanyDuns"}/>
        },
        {
            key: "experianBusinessId",
            label: <FormattedMessage id={"Entities_Review_Error_errorCompanies.CompanyExperian"}/>
        },
        {
            key: "categoryIDs",
            label: <FormattedMessage id={"Entities_Edit_UIText_thirdPartyListing.categoriesColumnHeading"}/>
        },
        {
            key: "createdDate",
            label: <FormattedMessage id={"Entities_Review_UIText_reviewCompanies.uploadDate"}/>,
            sortable: true,
            persistableSort: PAGE_NAME_REVIEW_AND_ACTIVATE
        },
        {
            key: "actions",
            label: ""
        }
    ];

    handlePreview() {
        const previewItems = this.state.selectedItems.map(item => item.object);
        actions.setPreviewItems([]);
        actions.setPreviewAll(false);
        actions.setPreviewItems(previewItems);
        actions.setSelectedItems(previewItems);
        hashHistory.push('/preview-company/' + previewItems[0].id);
    }

    handlePreviewAll() {
        this.clearSelections();
        actions.setPreviewItems([]);
        actions.setPreviewAll(true);
        actions.setSelectedItems([]);
        actions.startPreviewAll();
    }

    handleBulkActive() {
        super.handleBulkActive().then(() => {
            this.clearSelections();
        })
    }

    render() {
        const buttons = <div className="table-buttons">
            <BulkPreviewButton action={this.handlePreview} disabled={this.state.selectedItems.length === 0}/>
            <BulkActivateButton action={this.handleBulkActive}  disabled={this.state.selectedItems.length === 0}/>
            <DeleteButton action={this.handleBulkDelete} disabled={this.state.selectedItems.length === 0}/>
            <AssignToCategory categories={this.state.categories}
                              disabled={this.state.selectedItems.length === 0}
                              onSave={this.handleAssignCategory}/>
        </div>;

        return <div className="inactive-entities manage-entities listing-page standard-table">
            <ListingPageHeader
                onClick={this.handlePreviewAll}
                disabled={this.state.totalCount === 0}
                className={"preview-entities-header disabled"}
                buttonMessageId={"Entities_Review_UIText_reviewCompanies.previewAll"}>
                <div className={'preview-notice'}>
                    <FormattedMessage id="Entities_Review_UIText_reviewCompanies.noticePart1" />&nbsp;<span
                    className="review-companies-page__notice--number">{this.state.totalCount}</span>&nbsp;<FormattedMessage
                    id="Entities_Review_UIText_reviewCompanies.noticePart2" />
                </div>
            </ListingPageHeader>

            <div className="entities-table selectable-table">
                <Table {...this.getTableProps()}
                       selectedItems={sortBy(this.state.selectedItems, item => item.companyTitle.props.value.toLowerCase())}
                       actions={buttons}
                       filters={this.getFilters()}
                       fullScreen/>
            </div>
            {this.state.activeModal && this.state.activeModal}
        </div>;
    }
}

export default injectIntl(InactiveEntityListing);


// WEBPACK FOOTER //
// ./src/scripts/pages/Entities/InactiveEntitiesListing.jsx